import { Star, MapPin, Users, Clock, BadgeCheck, Heart } from "lucide-react";
import { euro } from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export const ServiceCard = ({ service }) => {
  const navigate = useNavigate();
  const { user, isFav, toggleFav } = useAuth();
  const fav = isFav(service.id);

  const onFav = async (e) => {
    e.stopPropagation();
    if (!user) { toast.info("Bitte melde dich an, um Favoriten zu speichern."); return; }
    const now = await toggleFav(service.id);
    toast.success(now ? "Zu Favoriten hinzugefügt" : "Aus Favoriten entfernt");
  };

  return (
    <div
      data-testid={`service-card-${service.id}`}
      onClick={() => navigate(`/angebot/${service.id}`)}
      className="bg-white rounded-2xl border border-slate-200/80 shadow-sm hover:shadow-lg hover:border-emerald-500/50 transition-all duration-200 overflow-hidden group cursor-pointer flex flex-col"
    >
      <div className="relative h-48 overflow-hidden">
        <img src={service.image_url} alt={service.title} loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        <div className="absolute top-3 left-3 flex gap-2">
          {service.verified && (
            <span className="flex items-center gap-1 bg-white/95 text-emerald-700 text-xs font-semibold px-2.5 py-1 rounded-full shadow-sm">
              <BadgeCheck className="w-3.5 h-3.5" /> Verifiziert
            </span>
          )}
        </div>
        <button onClick={onFav} data-testid={`fav-${service.id}`}
          className="absolute top-3 right-3 w-9 h-9 rounded-full bg-white/95 flex items-center justify-center shadow-sm hover:scale-110 transition-transform">
          <Heart className={`w-5 h-5 ${fav ? "fill-rose-500 text-rose-500" : "text-slate-500"}`} />
        </button>
        <div className="absolute bottom-3 right-3 flex items-center gap-1 bg-slate-900/85 text-white text-xs font-bold px-2.5 py-1 rounded-full">
          <Star className="w-3.5 h-3.5 fill-amber-400 text-amber-400" /> {service.rating}
        </div>
      </div>
      <div className="p-4 flex flex-col flex-1">
        <div className="flex items-center gap-1 text-xs text-slate-500 font-medium mb-1">
          <MapPin className="w-3.5 h-3.5" /> {service.city} · von {service.partner_name}
        </div>
        <h3 className="font-heading font-bold text-lg text-slate-900 leading-tight">{service.title}</h3>
        <div className="mt-3 mb-3 bg-emerald-50 border border-emerald-100 rounded-xl px-3 py-2.5">
          <div className="flex items-center gap-3 text-xs text-emerald-800 font-semibold mb-1">
            <span className="flex items-center gap-1"><Users className="w-3.5 h-3.5" /> {service.base_persons} Pers.</span>
            <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {service.base_hours} Std</span>
          </div>
          <div className="font-mono font-extrabold text-xl text-emerald-700">{euro(service.base_price)}</div>
          {service.extra_person_price > 0 && (
            <div className="text-xs text-emerald-700/70">+ {euro(service.extra_person_price)} / weitere Person</div>
          )}
        </div>
        <button className="mt-auto w-full bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-2.5 rounded-xl transition-colors"
          data-testid={`view-service-${service.id}`}>
          Details ansehen
        </button>
      </div>
    </div>
  );
};
